/**
 * K2-3026 follow-up: `isPartnerEnabled()` and the shared `isCheckoutDisabled` computed were
 * duplicated verbatim between Microcart.vue and ReorderList.vue, enforced through two different
 * mechanisms (a `:disabled` attribute vs. a click-time toast) - a future change to either rule
 * (e.g. a new disabled-partner reason) had to be made in both places or the two would drift.
 *
 * `isPartnerEnabled` is exported standalone, not folded into the mixin's computed, because its
 * callers disagree on shape: Microcart checks every partner across the whole cart
 * (getGroupedByPartnerProducts), ReorderList checks a single order's own partner - only the
 * partner-eligibility predicate itself is identical, not how it's aggregated.
 *
 * `partner` may be undefined (an order the API returned without an embedded partner object -
 * see RecentOrderReorder.vue's own order.partner-may-be-falsy handling): treated as "unknown",
 * not "disabled", so a missing partner never crashes this check or blocks on data the caller
 * simply doesn't have.
 */
export function isPartnerEnabled (partner) {
  return !partner || Boolean(partner.active && partner.enabled)
}

export default {
  computed: {
    isCheckoutDisabled () {
      return this.getGroupedByPartnerProducts.filter(group => {
        return group.partner.minimal_order_amount && group.partner.minimal_order_amount > group.subtotal
      }).length > 0
    }
  }
}
